import React from "react";
import { useDispatch } from "react-redux";
import { setCurrentPassage } from "../app/projectSlice";
import PropTypes from 'prop-types';
import {jumpTo} from "../Utils";
import variables from "../Story/variables";

const Link = (props) => {
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(setCurrentPassage(props.to));
        variables.game.nowIsStory = true;
        const variables_ = variables;
        if (props.variable) {
            const variable = eval("variables_." + props.variable);
            return jumpTo(variable);
        }
        if (props.callback) props.callback();
    };

    return (
        <span>&nbsp;
            {
                !props.disabled ?
                    <a className="game-link" href="#" onClick={onClick} style={props.style}>{props.children}</a> :
                    <span className="game-link-disabled">{props.children}</span>
            }
        </span>

    );
};

Link.propTypes = {
    to: PropTypes.string.isRequired,
    callback: PropTypes.func,
    variable: PropTypes.string,
    disabled: PropTypes.bool,
    style: PropTypes.object,
    div: PropTypes.bool
};

export default Link;